import * as Yup from 'yup'
import {BaseEntity} from '../../../shared/models/ApiModels'
import {ICustomerModel} from './CustomerModel'

/** Müşteri listesi satırı — tablo kolonlarıyla uyumlu DTO */
export interface ICustomerListRow extends BaseEntity {
  firstName: string
  lastName: string
  cepTel: string
  tel2: string
  tel3: string
  emailAddress: string
  tcKimlikNo: string
  taxNumber: string
  taxOffice: string
  address: string
  district: string
  city: string
  islemSube: string
  bakiyeSube: string
  /** İkinci Soyad kolonu (liste tanımına uygun) */
  soyadYedek: string
  onem: string
  ozelKod: string
  uyari: string
  uyariTarih: string
  yetkili: string
  yetkiliTel: string
  yetkiliMail: string
  musteriTemsilcisi: string
  dogumTarihi: string
  pasaportNo: string
  unvan1: string
  yetkili1: string
  yetkiliTel1: string
  yetkiliMail1: string
  unvan2: string
  yetkili2: string
  yetkiliTel2: string
  yetkiliMail2: string
  unvan3: string
  yetkili3: string
  yetkiliTel3: string
  yetkiliMail3: string
}

export interface ICustomerListFilter {
  cariAra: string
  soyad: string
  dateFilterType: string
  startDate: Date | null
  endDate: Date | null
  cariTipi: string
  activeStatus: string
  /** Hepsi (Tüm Kayıtlar) */
  allRecords: boolean
}

export const CUSTOMER_LIST_DATE_FILTER = [
  {value: 'IGNORE', label: 'Tarih Önemsiz'},
  {value: 'TRANSACTION', label: 'İşlem tarihi'},
] as const

export const CUSTOMER_LIST_CARI_TIPI = [
  {value: 'INDIVIDUAL', label: 'Bireysel'},
  {value: 'CORPORATE', label: 'Kurumsal'},
  {value: 'WARNING_LIST', label: 'Uyarı Liste'},
  {value: 'PERMIT_LIST', label: 'İzinli Liste'},
  {value: 'BIRTHDAY_LIST', label: 'Doğum Günü Liste'},
  {value: 'BIRTHDAY_WARNING', label: 'Doğum Günü Uyarı'},
  {value: 'ALL', label: 'Hepsi'},
] as const

export const CUSTOMER_LIST_ACTIVE = [
  {value: 'ACTIVE', label: 'Aktif'},
  {value: 'PASSIVE', label: 'Pasif'},
  {value: 'ALL', label: 'Hepsi'},
] as const

export const initialCustomerListFilter: ICustomerListFilter = {
  cariAra: '',
  soyad: '',
  dateFilterType: 'IGNORE',
  startDate: new Date(),
  endDate: new Date(),
  cariTipi: 'ALL',
  activeStatus: 'ACTIVE',
  allRecords: false,
}

export const validationCustomerListFilter = Yup.object().shape({})

function fmtDate(d: string | undefined | null): string {
  if (!d) return ''
  const t = String(d).slice(0, 10)
  return t
}

/** API / liste cevabından satır üretir; ek alanlar backend genişletmesiyle dolar */
export function mapCustomerToListRow(c: ICustomerModel): ICustomerListRow {
  const x = c as unknown as Record<string, string | undefined>
  return {
    id: c.id ?? null,
    firstName: c.firstName ?? '',
    lastName: c.lastName ?? '',
    cepTel: c.gsm1 ?? '',
    tel2: c.gsm2 ?? '',
    tel3: c.phone ?? '',
    emailAddress: c.emailAddress ?? '',
    tcKimlikNo: c.tcKimlikNo != null ? String(c.tcKimlikNo) : '',
    taxNumber: c.taxNumber != null ? String(c.taxNumber) : '',
    taxOffice: c.taxOffice ?? '',
    address: c.address ?? '',
    district: c.district ?? '',
    city: c.city ?? '',
    islemSube: x.operationBranchName ?? String(c.operationBranch ?? ''),
    bakiyeSube: x.balanceBranchName ?? String(c.balanceVisibleBranch ?? ''),
    soyadYedek: c.lastName ?? '',
    onem: x.onem ?? x.importance ?? '',
    ozelKod: c.specialCode ?? '',
    uyari: c.warningMessage ?? '',
    uyariTarih: fmtDate(c.warningTime ?? c.riskMessageDate),
    yetkili: x.yetkili ?? x.authorizedPerson ?? '',
    yetkiliTel: x.yetkiliTel ?? '',
    yetkiliMail: x.yetkiliMail ?? '',
    musteriTemsilcisi: x.customerRepresentativeName ?? String(c.customerRepresentative ?? ''),
    dogumTarihi: fmtDate(c.dateOfBirth),
    pasaportNo: c.passportNumber ?? '',
    unvan1: x.unvan1 ?? x.title1 ?? '',
    yetkili1: x.yetkili1 ?? '',
    yetkiliTel1: x.yetkiliTel1 ?? x.firstOfficerPhone ?? '',
    yetkiliMail1: x.yetkiliMail1 ?? x.firstOfficerEmail ?? '',
    unvan2: x.unvan2 ?? x.title2 ?? '',
    yetkili2: x.yetkili2 ?? '',
    yetkiliTel2: x.yetkiliTel2 ?? x.secondOfficerPhone ?? '',
    yetkiliMail2: x.yetkiliMail2 ?? x.secondOfficerEmail ?? '',
    unvan3: x.unvan3 ?? x.title3 ?? '',
    yetkili3: x.yetkili3 ?? '',
    yetkiliTel3: x.yetkiliTel3 ?? x.thirdOfficerPhone ?? '',
    yetkiliMail3: x.yetkiliMail3 ?? x.thirdOfficerEmail ?? '',
  }
}
